import styled from 'styled-components/macro';

import * as colors from 'components/common/colorConstants';
import { TicketTextBold, TicketTextRegular } from '../../common/fontElements';
import { selectedMessageText } from '../../common/colorConstants';
import { SearchSelectHolderComponent } from '../../common/dropDownComponents';
import { TicketsFiltersLabelsText } from '../../common/fontElements';
import TicketButton from '../../Buttons/TicketButton/TicketButton';
import { highlightedInlineText } from '../../common/cssStyles';
import { smallScreens, mediumScreens, lowHeightScreens } from '../../common/fontElements';

export const ErrorMessage = styled.p`
  color: ${colors.red2};
  font-size: 14px;
`;

export const FieldWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;
`;

export const Container = styled.div`
  background-color: ${colors.baseBackground};
  color: ${selectedMessageText};
  border-bottom: 1px solid ${colors.lightGray39};
  box-shadow: 0px 3px 4px ${colors.lightGray7};
`;

export const ExpertTools = styled.div`
  flex-basis: auto;
  display: flex;
  flex-direction: row;
  padding: 12px 20px;
  border-top: 1px solid ${colors.lightGray39};
  background-color: ${(props) => (props.isSelectedHistoricalTicket ? colors.lightGray14 : colors.baseBackground)};
`;

export const SpecialistTools = styled.div`
  flex-basis: auto;
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: space-between;
  padding: 13px 20px 3px 20px;
  border-top: 1px solid ${colors.lightGray39};
`;

export const PartnerProtectorTools = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 20px 10px 56px;
  border-top: 1px solid ${colors.lightGray39};
  background-color: ${colors.blue1};
`;

export const ToolHeader = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  img {
    cursor: pointer;
  }
`;

export const CloseContainer = styled.div`
  display: block;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 10px 00px 0px 0px;

  img {
    cursor: pointer;
  }
`;

export const ToolPlaceholder = styled(ToolHeader)`
  justify-content: flex-end;
  padding: 10px 20px 10px 20px;
  border-top: 1px solid ${colors.lightGray39};
  flex-basis: auto;
  display: flex;

  img {
    margin-left: 20px;
  }
`;

export const AttachmentsPlaceholder = styled(ToolHeader)`
  justify-content: flex-start;
  padding: 10px 20px 10px 20px;
  border-top: 1px solid ${colors.lightGray39};
  flex-basis: auto;
  display: flex;

  img {
    margin-left: 20px;
  }
`;

export const TicketTextBoldBlue = styled(TicketTextBold)`
  cursor: pointer;
  color: ${colors.blue1};
`;

export const TicketTextBoldGray = styled(TicketTextBold)`
  cursor: pointer;
  color: ${colors.darkGray1};
`;

export const TicketTextBoldWhite = styled(TicketTextBold)`
  cursor: pointer;
  color: ${colors.whiteText};
  margin-right: 6px;
`;

export const SmallTextWhite = styled(TicketTextBoldWhite)`
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 11px;
`;

export const ToolSection = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0px;
  width: calc(100 - 100px);
`;

export const MessageTypeImage = styled.div`
  align-self: flex-start;
  display: flex;
  justify-content: center;
  & img {
    height: 25px;
    width: 25px;
  }
`;

export const MessageLeftDetails = styled.div`
  overflow-x: hidden;
  flex: 5;
  align-self: flex-start;
  padding-left: 10px;
`;

export const MessageRightDetails = styled.div`
  text-align: right;
  align-self: flex-start;
  margin-left: 50px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
`;

export const TicketDateText = styled(TicketTextRegular)`
  margin-left: 10px;
  white-space: nowrap;
  color: ${colors.darkGray1};
`;

export const FromDetails = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 8px;
`;

export const TicketInfo = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  color: ${colors.black4};
  font-weight: 500;
  align-content: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const GrayTicketText = styled(TicketTextRegular)`
  white-space: pre-wrap;
  margin-top: 5px;
  ${highlightedInlineText};
  color: ${colors.darkGray1};
`;

export const MessageCounter = styled.div`
  color: ${colors.darkGray1};
  font-family: 'Roboto', sans-serif;
  font-size: 9px;
  line-height: 12px;
  padding: 2px 8px;
  border-radius: 3px;
  border: 1px solid ${colors.darkGray1};
  text-align: center;
  text-transform: uppercase;
`;

export const Divider = styled.div`
  width: 1px;
  height: 8px;
  background-color: ${colors.lightGray2};
  border-radius: 8px;
  align-self: center;
`;

export const ExternalLink = styled.a`
  color: ${colors.purple1};
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
`;

export const SelectHolder = styled(SearchSelectHolderComponent)`
  margin: 0px 13px 10px 0px;
  width: 150px !important;
  margin-left: ${(props) => (props.label ? '3px' : '0px')};
  z-index: 200;
  position: relative;

  .Select .Select-menu-outer {
    border-color: ${colors.lightGray21} !important;
    background-color: ${colors.baseBackground} !important;
  }

  .Filter .Select-arrow {
    color: ${colors.black} !important;
    border-top-color: ${colors.darkGray14} !important;
  }

  .Filter .Select-control {
    border-color: ${colors.lightGray21} !important;
    height: 25px !important;
  }
`;

export const SelectOuterHolder = styled.div`
  width: 150px;
  max-width: 490px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-content: flex-start;
`;

export const Label = styled(TicketsFiltersLabelsText)`
  font-family: 'Lato-Bold', sans-serif;
  line-height: 25px;
`;

export const Icon = styled.img`
  width: 140px;
  cursor: pointer;

  @media screen and (max-width: ${mediumScreens}) {
    width: 140px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    width: 120px;
  }
`;

export const ExpertReviewIcon = styled(Icon)`
  margin: 5px 0 5px 0;
`;

export const Button = styled(TicketButton)`
  margin: 0px 10px 10px 0px !important;
`;
